import cache from 'memory-cache';

interface CacheRequest {
  _key: string;
  cb: () => Promise<any>;
  minutesValid?: number;
}

/**
 * Returns a cache-hit or returns the result of an async function call and caches it.
 */
export async function getCacheOrCall<T>({ _key, cb, minutesValid = 10 }: CacheRequest): Promise<T> {
  const hit = cache.get(_key);
  if (hit) {
    return hit;
  }

  const result = await cb();
  cache.put(_key, result, minutesValid * 1000 * 60);
  return result;
}
